import * as ApiManager from './_manager';
import store from '@/store';

export const affiliation = {
  updateHits: payload => {
    return ApiManager.callApi (
      `/guest/company/referral/updateHits`,
      payload
    );
  }
};
